import { StyleSheet } from 'react-native'
import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  inputText: theme => ({
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6
  })
})

export default styles
